import type { TranslationMessages } from '../../types';

export const header: TranslationMessages = {
  title: 'Neko của tôi',
  subtitle:
    'Bảng điều khiển cá nhân của bạn cho công việc, phần thưởng và sự phát triển',
};
